import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { CreatePromptRequest, QueryKey } from 'api/model';
import { toast } from 'react-toastify';
import { create as createRequest, getGlobalList, getProjectList } from './requests';
import { errorHandler } from 'api/axios_instance';

const queryKey = QueryKey.Prompts;

const usePrompts = (
  projectId: string | null = null,
  includeGlobalPrompts = false,
  unusedOnly = false,
  enabled = true,
) => {
  const queryClient = useQueryClient();

  const queryFn = () =>
    projectId === null ? getGlobalList(unusedOnly) : getProjectList(projectId, includeGlobalPrompts, unusedOnly);
  const {
    data: prompts,
    isLoading,
    isFetching,
  } = useQuery({
    queryKey: [queryKey, { projectId, includeGlobalPrompts, unusedOnly }],
    queryFn: queryFn,
    staleTime: 1000 * 60 * 5, // 5 minutes
    enabled,
  });

  const create = useMutation({
    mutationFn: (prompt: CreatePromptRequest) => createRequest(prompt),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [queryKey] });
      void queryClient.invalidateQueries({ queryKey: [QueryKey.PromptFolders] });
      toast.success('Prompt successfully created');
    },
    onError: errorHandler('Creating prompt failed'),
  });

  return { prompts, isLoading, create, isFetching };
};

export { queryKey };
export default usePrompts;
